// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// globale Config
window.Parsley.options.uiEnabled = true;
window.Parsley.options.validationThreshold = 1;
window.Parsley.options.trigger = 'keyup focusout'; // focusin vorerst entfernt
window.Parsley.options.errorClass = 'is-invalid';
window.Parsley.options.successClass = 'is-valid';
window.Parsley.options.errorsWrapper = '<div class="invalid-feedback"></div>';
window.Parsley.options.errorTemplate = '<div></div>';


// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// gt, gte, lt, lte, notequalto extra validators
// aus node_modules/parsleyjs/src/extra/validator/comparison.js
// auskommentiert wurden nur die, die wir aktuell nicht brauchen
// die beiden gt und lt sind neue custom-Validatoren basierend auf ihren Originalen - gleicher Name wg. Translations :-)

var parseRequirement = function (requirement) {
    if (isNaN(+requirement))
        return parseFloat(jQuery(requirement).val());
    else
        return +requirement;
};

// Greater than validator with optional ref-field
window.Parsley.addValidator('gt', {
    validateString: function (value, requirement) {
        jQuery(requirement).parsley().reset();
        if (jQuery(requirement).val() != '') {
            return parseFloat(value) > parseRequirement(requirement);
        } else {
            return true; // zweites Feld ist optional
        }
    },
    priority: 32
});

// Less than validator with optional ref-field
window.Parsley.addValidator('lt', {
    validateString: function (value, requirement) {
        jQuery(requirement).parsley().reset();
        if (jQuery(requirement).val() != '') {
            return parseFloat(value) < parseRequirement(requirement);
        } else {
            return true; // zweites Feld ist optional
        }
    },
    priority: 32
});
